<template>
  <ThePage />
</template>

<script>
import ThePage from "@/components/the-page/vue/ThePage.vue";

export default {
  name: "App",
  components: {
    ThePage,
  },
};
</script>
<style lang="scss">
@import "@/static/styles/global";
</style>
